//dateRange

$(".dateRange").on("change", function(e) {
	e.preventDefault();

	var month = $("#month").val();
	var year = $("#year").val();

	window.location = location.protocol + '//' + location.host + "/events/" + year + "/" + month + "#calendarHeader";


});
